import React, { Component } from 'react';
import {connect} from 'react-redux'
import flow from 'lodash/flow'

import withStyles from 'material-ui/styles/withStyles'

class Footer extends Component {


    render() {
        const {classes} = this.props;

        return (<footer className={classes.footer}>Evoenergy</footer>)
    }
}

const mapStateToProps = (state) => {
    return {
    }
}


const styles = (theme) => ({
    footer: {
        padding: theme.spacing.large,
        textAlign: 'center'
    }
})

export default flow([
    connect(mapStateToProps, null),
    withStyles(styles)
])(Footer);




// WEBPACK FOOTER //
// ./src/components/Footer.js